module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" title=\"Current Active Behaviors\" >\r\n    <ul style=\"list-style-type:none !important\">\r\n        ")
    ; 
        items.forEach(function(item, index){
        
    ; __append("\r\n        <div style=\"float:left; padding-right:10px;height:18px\">")
    ; __append(escapeFn(item.owner))
    ; __append("</div>\r\n        <div style=\"height:18px\">\r\n          <li style = \"cursor:pointer\">\r\n              <a class=\"item-behavior\" data-index=\"")
    ; __append(escapeFn(index))
    ; __append("\" data-id=\"")
    ; __append(escapeFn(item.id))
    ; __append("\">- ")
    ; __append(escapeFn(item.text))
    ; __append("</a>\r\n          </li>\r\n        </div>\r\n        ")
    ; 
        })
        
    ; __append("\r\n    </ul>\r\n\r\n</div>")
  }
  return __output;

}